import { render, staticRenderFns } from "./Myreferrals.vue?vue&type=template&id=6b68e13b&scoped=true&"
import script from "./Myreferrals.vue?vue&type=script&lang=ts&"
export * from "./Myreferrals.vue?vue&type=script&lang=ts&"
import style0 from "./Myreferrals.vue?vue&type=style&index=0&id=6b68e13b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b68e13b",
  null
  
)

export default component.exports